import { useState } from 'react'
import service from '../../../@services'
import { Form, InputNumber, Col, Row, Input } from 'antd'
import useModalForm from '../../../@hooks/useModalForm'
import { StoreCode } from '../context'
import { useContext, useRef } from 'react'
import { plusMumber } from '../../../@utils'
import { StockStoreTypeMap } from '../config'
import * as Utils from '../../../@utils'
const noBorderStyle = {
  border: 'none',
  background: 'none'
}
const maxNum = 99999999
const BasicForm = ({ originForm }) => {
  const [form] = Form.useForm(originForm)
  const timeout = useRef(null)
  const [changedNum, setChangedNum] = useState('')
  const changeStock = val => {
    setChangedNum(val)
    timeout.current && clearTimeout(timeout.current)
    timeout.current = setTimeout(() => {
      let _changedNum = form.getFieldValue('changedNum')
      let oldVal = form.getFieldValue('beforeStock')
      parseInt(_changedNum) &&
        form.setFieldsValue({
          stock: plusMumber(oldVal, _changedNum - 0)
        })
      timeout.current = null
    }, 100)
  }
  let _oldVal = form.getFieldValue('beforeStock')
  let maxFinal = maxNum - _oldVal
  let minFinal = -maxNum + _oldVal
  return (
    <Form form={form}>
      <Row justify='space-between'>
        <Col span='10'>
          <Form.Item name='beforeStock' label='当前库存'>
            <Input disabled style={noBorderStyle} />
          </Form.Item>
        </Col>
        <Col span='10'>
          <Form.Item name='stock' label='调整后库存'>
            {changedNum ? <Input disabled style={noBorderStyle} /> : '--'}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span='10'>
          <Form.Item
            name='changedNum'
            rules={[
              {
                required: true,
                message: '请输入调整值',
                pattern: /^[-|+]?\d+$/
              }
            ]}
            label='库存调整'
            help={<p style={{ color: '#FA4B54' }}>注：正数+，负数-</p>}>
            <InputNumber
              controls={false}
              placeholder='请输入调整值'
              onChange={changeStock}
              max={maxFinal}
              min={minFinal}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default function useBatchUpdateStock(freshList = () => {}) {
  const { storeCode } = useContext(StoreCode)
  const [selectedItems, setSelectedItems] = useState([])
  const { open } = useModalForm(BasicForm)
  const confirmEdit = async params => {
    let res = await service.inventory.updateStockBySkuid({
      ...params,
      storeCode
    })
    freshList({})
    return res
  }
  const editStockBatch = product => {
    open(
      res => confirmEdit({ stock: res.stock, skuId: product.skuId }),
      {
        stock: product.stock,
        beforeStock: product.stock
      },
      { title: '库存调整' }
    )
  }
  const exportData = async basicParams => {
    let res = await service.inventory.exportStockList(basicParams)
    let fileName =
      StockStoreTypeMap[basicParams.stockStoreType] +
      Utils.parseTime(Date.parse(new Date())) +
      '.xlsx'
    Utils.download(res, fileName)
  }
  return { exportData, setSelectedItems, editStockBatch }
}
